import {gql} from '@apollo/client';

export const MUTATION_VISIT = gql`
    mutation visitOnlyCash ($session: String!, $token: String, $provider: String) {
        visitOnlyCash(session: $session, token: $token, provider: $provider) {
            done
        }
    }
`